import { render, staticRenderFns } from "./TableInnerBG.vue?vue&type=template&id=c4af2528&scoped=true&"
import script from "./TableInnerBG.vue?vue&type=script&lang=js&"
export * from "./TableInnerBG.vue?vue&type=script&lang=js&"
import style0 from "./TableInnerBG.vue?vue&type=style&index=0&id=c4af2528&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4af2528",
  null
  
)

export default component.exports